import React from 'react';
import uniqid from 'uniqid';
import { Link as RouterLink } from 'react-router-dom';

import LessonsSidebarItem from 'containers/user/learn/containers/content/cources/course-details/course-sidebar/course-sidebar-item/course-sidebar-item';
import HorizontalProgressBar from 'containers/user/learn/components/horizontal-progress-bar/horizontal-progress-bar';
import Progress from 'containers/user/learn/components/progress/progress';

import Icons from 'assets/icons';

import { countAverageProgress } from 'containers/user/learn/containers/content/cources/courses.utils';

interface SidebarLesson {
  id: string | number;
  name?: string;
}

interface LessonsSidebarItemClickArgs {
  event: React.MouseEvent<HTMLAnchorElement>;
  to: string;
  id: string | number;
}

interface LessonsSidebarProps {
  lessons?: SidebarLesson[];
  lessonOnClick: (args: LessonsSidebarItemClickArgs) => void;
  courseId: string | number;
  currentLessonId: string | number;
  withHeader?: boolean;
  customWrapperClass?: string;
  lessonsProgress: Record<string, number>;
}

const LessonsSidebar = ({
  lessons,
  lessonOnClick,
  courseId,
  currentLessonId,
  withHeader = true,
  customWrapperClass = '',
  lessonsProgress,
}: LessonsSidebarProps): React.JSX.Element | undefined => {
  const averageProgress = countAverageProgress(lessonsProgress);

  if (!lessons) {
    return undefined;
  }

  return (
    <div className={`w-[300px] px-1.5 ${customWrapperClass}`}>
      {withHeader && (
        <>
          <RouterLink
            to={`/learn/course/${courseId}`}
            className="flex font-semibold items-center gap-1 text-blue-700 hover:text-navy-800 group mb-5"
          >
            <Icons.Arrow customClass="h-4 w-4 rotate-180 transition-transform duration-300 group-hover:-translate-x-1" aria-hidden="true" />
            <span>See course overview</span>
          </RouterLink>
          <HorizontalProgressBar
            progress={averageProgress}
            ariaLabel="Lesson progress"
            customClass="mb-1"
          />
          <Progress averageProgress={averageProgress} customClass="mb-3" />

          <h3 className="text-base font-semibold text-navy-500 mb-3">
            Lessons
          </h3>
        </>
      )}

      <div className="flex flex-col !w-full">
        <ol className="!w-full">
          {lessons.map((lesson, index) => (
            <LessonsSidebarItem
              {...lesson}
              key={uniqid()}
              index={index}
              onClick={lessonOnClick}
              courseId={courseId}
              currentLessonId={currentLessonId}
              progress={lessonsProgress[`lesson-${lesson?.id}`]}
            />
          ))}
        </ol>
      </div>
    </div>
  );
};

export default LessonsSidebar;
